import TurbineHealthHeatmap from './HeatmapTurbineHealth'
import TurbHealth from './TurbineHealth'

export { TurbineHealthHeatmap }

export default TurbHealth
